import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "@/services/cloudchipr.api";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";

interface GetBillingExplorerDimensionGroupingsThunk {
  enableCategoryGroupingFilterV2: boolean;
  forceRefetch?: boolean;
  filterValuesQuerySource: "resource_explorer" | "commitments" | "opportunity";
}

export const getBillingExplorerDimensionGroupingsThunk = createAsyncThunk(
  "billingExplorer/getBillingExplorerDimensionGroupings",
  async (
    {
      enableCategoryGroupingFilterV2,
      forceRefetch,
      filterValuesQuerySource,
    }: GetBillingExplorerDimensionGroupingsThunk,
    { dispatch },
  ) => {
    const {
      getUsersMeOrganisationsCurrentFiltersByFilterProviderAndFilterTypeValues,
    } = cloudChiprApi.endpoints;

    try {
      return dispatch(
        getUsersMeOrganisationsCurrentFiltersByFilterProviderAndFilterTypeValues.initiate(
          {
            filterProvider: "dimensions",
            filterType: enableCategoryGroupingFilterV2
              ? "category"
              : "dimension_id",
            querySource: filterValuesQuerySource,
          },
          {
            forceRefetch: forceRefetch,
          },
        ),
      ).unwrap();
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
      return null;
    }
  },
);
